<template>
  <transition name="modal">
    <div class="modal-mask" v-if="show">
      <div class="modal-wrapper">
        <div class="modal-container small">
          <div class="modal-header">
            <h4><b>{{ title }}</b></h4>
          </div>

          <div class="modal-body">
            <slot> </slot>
          </div>

          <div class="modal-footer">
            <button class="btn" @click="onClickNegative()"> {{ negativeText }} </button>
            <button class="btn btn-primary" @click="onClickPositive()"> {{ positiveText }} </button>
          </div>

        </div>
      </div>
    </div>
  </transition>
</template>

<script>

export default {
  props: {
    positiveText: {
      type: String,
      default: "Aceptar"
    },
    negativeText: {
      type: String,
      default: "Cancelar"
    },
    title: {
      type: String,
    },
    show: {
      type: Boolean,
      default: false,
    }
  },

  methods: {
    onClickPositive() {
      this.$emit('pressed-yes');
    },

    onClickNegative() {
      this.$emit('pressed-no');
    }
  }
}
</script>

<style scoped>
.modal {
  color: black;
}
</style>


// WEBPACK FOOTER //
// YesNoModal.vue?c8e168ae